import React, {useState, useRef} from "react";
import { Modal } from "./Modal";
import { YoutubePlayer } from "./YoutubePlayer";
import { compose } from "recompose";
import withTranslator from "../Translator/withTranslation";
import withFosRouter from "../FosRouter/withFosRouting";

const VillaVidFavButtonsComponent  = (props) => {
    const[modal, setModal] = useState(false);

    const favouriteRef = React.createRef();

    const onClose = ()  => {
        setModal(false);
    }

    const playVideo = () => {
        setModal(<Modal content={<YoutubePlayer data={props.data}  />} onClose={onClose} />);
    }

    const sendAddFavouriteEvent = (type) => {
        const event = {
            event: "micro_conversion",
            event_type: type,
            event_content: props.data.name,
            item_id : props.data.id,
        }
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(event);
        return true;
    }

    const addToFavourite = () => {
        var id = props.data.id;
        fetch(props.r('addfavourite', {id: id}))
            .then((resp) => resp.json())
            .then( function(data){
                id = parseInt(id);
                if ( data.ids.includes(id) === true) {
                    addFavouriteStyle();
                    // send google add favourites event
                    sendAddFavouriteEvent('favourite');
                } else {
                    removeFavouriteStyle();
                    sendAddFavouriteEvent('unfavourite');
                }

                var event = new CustomEvent("VillaVidFavButton_addToFavourite", {
                    detail: {
                        count: data.ids.length
                    }
                });

                document.dispatchEvent(event);
            });
    }

    const addFavouriteStyle = () => {
        var element = favouriteRef.current;
        element.classList.add(props.favouritedClass);
        element.querySelector('img').src = props.favouritedIcon;
    }
    
    const removeFavouriteStyle = () => {
        var element = favouriteRef.current;
        element.classList.remove(props.favouritedClass);
        element.querySelector('img').src = props.favButtonIcon;
    }

    const { data, t } = props;
    const active = {
        className: props.data.is_favourite ? props.favouritedClass : '',
        icon: props.data.is_favourite ? props.favouritedIcon : props.favButtonIcon
    };
    
    return (
        <div className="relative">
            {modal ? modal : ''}
            <div>
                {data.videoUrl ?
                <button onClick={playVideo} type="button" className={"select-none btn btn-xs mr-2 " + props.vidButtonClassName} title={'Video ' + data.name}>
                    <img className="block" src={props.vidButtonIcon} height={props.iconHeight} alt="video" />
                </button>
                : ''}
                <button key={"favbutton" + data.id} ref={favouriteRef} onClick={addToFavourite} type="button" className={"select-none btn btn-xs " + props.favButtonClassName + ' ' + active.className} title={t('addtofavourites')}>
                    <img key={"favimage" + data.id} className="block" src={active.icon} height={props.iconHeight} alt="favourite" />
                </button>
            </div>
        </div>
    );
}

export const VillaVidFavButtons = compose(
    withTranslator,
    withFosRouter
)(VillaVidFavButtonsComponent);